/* eslint-disable no-undef */
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import { PersistGate } from 'redux-persist/integration/react'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import * as serviceWorker from './serviceWorker'
import './css/spa.css';
import 'font-awesome/css/font-awesome.min.css';
import 'babel-polyfill';
import 'core-js';
//let {wwwUrl} = process.env.wwwUrl;
let wwwUrl = process.env.wwwUrl;
const { store, persistor } = configureStore()

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)
serviceWorker.unregister()
